// Generated by CoffeeScript 1.9.0
var Fasta, GenericReader;

GenericReader = require("biojs-io-parser");

Fasta = require("./fasta");

module.exports = Fasta;

GenericReader.mixin(Fasta);



//////////////////
// WEBPACK FOOTER
// ./~/biojs-io-fasta/lib/index.js
// module id = 19
// module chunks = 0